module.exports = __webpack_public_path__ + "static/media/Navigate Theme – Gallery – 1.55006cc7.jpg";